import { render, staticRenderFns } from "./CollapsableSegment.vue?vue&type=template&id=175ee6b4&"
import script from "./CollapsableSegment.vue?vue&type=script&lang=js&"
export * from "./CollapsableSegment.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableSegment.vue?vue&type=style&index=0&id=175ee6b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports